import { render, staticRenderFns } from "./StockCompareDashboard.vue?vue&type=template&id=1117fb61&"
import script from "./StockCompareDashboard.vue?vue&type=script&lang=js&"
export * from "./StockCompareDashboard.vue?vue&type=script&lang=js&"
import style0 from "./StockCompareDashboard.vue?vue&type=style&index=0&id=1117fb61&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports